import classNames from "classnames";

import { BoldText } from "components/BoldText/BoldText";
import { BaseLayout } from "components/BaseLayout/BaseLayout";

import styles from "./styles.module.scss";
import { PricelistFooter } from "./PricelistFooter";
import { PricelistBody } from "./PricelistBody";

const Header = (): JSX.Element => (
  <BoldText className={styles.groupTitle}>Прайс листы</BoldText>
);

export const Pricelist = (): JSX.Element => (
  <BaseLayout
    className={classNames("ml-2 mt-3 mb-3", styles.container)}
    header={<Header />}
    footer={<PricelistFooter />}
  >
    <PricelistBody />
  </BaseLayout>
);
